module.exports = __webpack_public_path__ + "static/media/iStock-1206648608.a3f54dc3.jpg";